import { C } from '../../theme.js';
import { Alert, FieldLabel } from '../../components/Primitives.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';

/* eslint-disable */

export function HashInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Column</FieldLabel>
      <ColSelect value={c.column} onChange={(v) => u({ column: v })} />
      <FieldLabel>Mode</FieldLabel>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
        {[
          { id: 'mask', label: 'Mask', desc: '••••3210' },
          { id: 'hash', label: 'Hash', desc: '8-char hex' },
          { id: 'md5', label: 'MD5', desc: '32-char hex' },
          { id: 'sha256', label: 'SHA-256', desc: '64-char hex' },
        ].map(m => {
          const on = (c.mode || 'mask') === m.id;
          return (
            <button key={m.id} onClick={() => u({ mode: m.id })}
              style={{
                fontFamily: 'inherit', cursor: 'pointer', textAlign: 'left',
                background: on ? 'var(--info-bg)' : C.input,
                color: on ? C.accentBright : C.fg3,
                border: `1px solid ${on ? C.accentMuted : C.border}`,
                borderRadius: 8, padding: '8px 10px',
                fontSize: '.78rem', fontWeight: 600,
              }}>
              <div>{m.label}</div>
              <div style={{ color: C.fg5, fontSize: '.7rem', marginTop: 2, fontFamily: "'JetBrains Mono', monospace" }}>{m.desc}</div>
            </button>
          );
        })}
      </div>
      {(c.mode === 'md5' || c.mode === 'sha256') && (
        <Alert kind="warn" style={{ marginTop: 12 }}>
          Hashing is irreversible. Make sure you've kept a copy of the original
          column if you need it downstream.
        </Alert>
      )}
    </div>
  );
}
